import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const ParticleBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log("Engine recibido:", engine);
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      init={particlesInit}
      options={{
        particles: {
          number: { value: 100 },
          move: { enable: true, speed: 1 },
          size: { value: 3 },
          color: {value:"#D92B04"},
                   
        },
      }}
    />
  );
};

export default ParticleBackground;
